<template>
  <div :class="{ deactivateLinks: deactivateLinks }">
    <div class="title" v-if="title">{{ title }}</div>
    <div v-if="hasHeaders" class="colorCaption d-flex flex-row px-4">
      <v-spacer></v-spacer>
      <!-- <div v-html="fieldByField"></div> -->
      <vue-markdown class="mdContent" :key="fieldByField">
        {{ fieldByField }}</vue-markdown
      >
    </div>
    <div
      v-for="(group, i) in groups"
      :key="'group_m' + i"
      class="py-2"
      style="background-color: #fafafa; border: 1px solid #dddddd"
    >
      <div
        v-if="group.name && groups.length > 1"
        class="font-weight-bold text-center pa-2"
        :style="groupHeaderStyle"
      >
        <vue-markdown class="mdContent" :key="group.name + i">{{
          group.name
        }}</vue-markdown>
      </div>

      <!-- if there are 2 columns just show a 2 column table -->
      <table v-if="headerCount == 2" class="ma-2" style="min-width: 95%">
        <tr v-for="(row, rowIndex) in group.items" :key="'row_m1' + rowIndex">
          <!-- :class="rowIndex % 2 == 0 ? 'grayBkg' : ''" -->
          <th class="text-left pa-1 colorCaption">
            <div>
              <vue-markdown class="mdContent" :key="'cell1MD_' + rowIndex">{{
                row[0]
              }}</vue-markdown>
            </div>
          </th>
          <td class="pa-1"><list-or-text :content="row[1]"></list-or-text></td>
        </tr>
      </table>

      <!-- if >2 column table show each column as a row-->
      <div v-else>
        <div
          v-for="(row, rowIndex) in group.items"
          :key="'row_m' + rowIndex"
          class="groupBorder pa-1"
        >
          <table class="width100p">
            <tr
              v-for="(cell, cellIndex) in row"
              :key="`m_${rowIndex}_${cellIndex}`"
            >
              <!--     :class="cellIndex % 2 == 0 ? 'grayBkg' : ''" -->
              <th
                v-if="cellIndex == 0"
                colspan="2"
                class="pa-1 text-left"
                :style="headerStyle"
              >
                <vue-markdown
                  class="mdContent"
                  :key="cell + `cellMD_${rowIndex}_${cellIndex}`"
                  >{{ cell }}</vue-markdown
                >
              </th>
              <th v-if="cellIndex > 0" class="text-left pa-1 colorCaption">
                <vue-markdown
                  class="mdContent"
                  :key="headers[cellIndex] + 'cell0MD_' + i"
                  >{{ headers[cellIndex] }}</vue-markdown
                >
              </th>
              <td v-if="cellIndex > 0" class="pa-1">
                <list-or-text :content="cell"></list-or-text>
              </td>
            </tr>
          </table>
        </div>
      </div>
      <!-- end >2 column table -->
    </div>
    <div v-if="notes" class="pa-2">
      <vue-markdown class="mdContent" :key="notes">{{ notes }}</vue-markdown>
    </div>
  </div>
</template>

<script>
// import Name from "../dir/file";
import ListOrText from "@/components/pagesStuff/ListOrText";
import VueMarkdown from "@adapttive/vue-markdown";

export default {
  name: "DataTableMobile",
  components: { ListOrText, VueMarkdown },
  props: {
    headers: null,
    groups: null,
    notes: null,
    hasHeaders: { type: Boolean, default: true },
    headerStyle: {
      type: String,
      default: "background-color: #f0f9ff; border: 1px solid #b8c4cb;",
    },
    groupHeaderStyle: {
      type: String,
      default: "background-color: #d9f1ff;border: 1px solid #92bbd6; ",
    },
    tableStyle: { type: String, default: "border: 1px solid #95b8d1;" },
    notesClass: { type: String, default: "caption" },
    deactivateLinks: null, // makes links inactive (eg when previewing in admin and don't want to accidentally navigate away)
    title: null,
    // groupStyle: {
    //   type: String,
    //   default: "background-color: #bfe7ff;",
    // },
  },
  data: function () {
    return {};
  },
  methods: {},
  computed: {
    headerCount: function () {
      return this.headers?.length;
    },
    fieldByField: function () {
      if (!this.hasHeaders) return null;
      let rtn = "";
      if (this.headerCount == 2) rtn += ` ${this.headers[1]}`;
      if (this.headerCount > 1) rtn += ` by ${this.headers[0]}`;
      return rtn;
    },
    // hasHeaders: function () {
    //   let rtn = false;
    //   this.headers.forEach((h) => {
    //     if (h && h != "") rtn = true;
    //   });
    //   return rtn;
    // },
  },
};
</script>

<style scoped>
.borderBottom {
  border-bottom: 1px solid #e3e3e3;
}

.groupBorder {
  /* border: 1px solid #a4a4a4; */
  margin: 0 5px 5px;
}
.grayBkg {
  background-color: #efefef;
}
table {
  border-collapse: collapse;
}
th,
td {
  vertical-align: top;
  border-bottom: 1px solid #dfdfdf;
}
th {
  min-width: 70px;
}
.colorCaption {
  font-size: 0.85rem !important;
  font-weight: 500;
  /* letter-spacing: 0.0333333333em !important; */
  line-height: 1.25rem;
  font-family: "Roboto", sans-serif !important;
  color: #00264f;
}
.deactivateLinks >>> a {
  pointer-events: none;
}
</style>
